import type { ChangeEvent } from 'react';

import { fieldStyle, MONO } from '../venueCreateFields';

interface PrefixInputProps {
  prefix: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  error?: boolean;
}

/**
 * Input with a small non-editable prefix box adjoining its left edge (e.g. `@`
 * or `facebook.com/`). The prefix is purely presentational — the user types
 * only the handle, and `value`/`onChange` carry just the handle. Used by the
 * Social Presence section (BON-168).
 */
export function PrefixInput({ prefix, value, onChange, placeholder, error }: PrefixInputProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'stretch' }}>
      <span
        aria-hidden="true"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          height: 32,
          padding: '0 8px',
          fontSize: 12.5,
          fontFamily: MONO,
          color: 'var(--nb-subtle)',
          background: 'var(--nb-bg-2, var(--nb-bg))',
          borderStyle: 'solid',
          borderWidth: '1px 0 1px 1px',
          borderColor: error ? 'var(--nb-risk)' : 'var(--nb-border-2)',
          borderRadius: '8px 0 0 8px',
          whiteSpace: 'nowrap',
        }}
      >
        {prefix}
      </span>
      <input
        value={value}
        aria-invalid={error || undefined}
        placeholder={placeholder}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        style={fieldStyle(error ? 'error' : undefined, {
          fontFamily: MONO,
          borderRadius: '0 8px 8px 0',
        })}
      />
    </div>
  );
}
